import { createAction, props } from '@ngrx/store';
import {
  TokenResponse,
  IAdminTokenPayload,
  ResetResponse
} from '@care-portals/api-interfaces';

export const validateAuth = createAction('[Auth] Validate Auth');

export const unauthenticatedState = createAction(
  '[Auth] Unauthenticated State',
  props<{ redirectUrl?: string }>()
);

export const logIn = createAction(
  '[Auth] Login',
  props<{ username: string; password: string }>()
);

export const redirect = createAction(
  '[Auth] Redirect',
  props<{ redirectUrl: string }>()
);

export const logInSuccess = createAction(
  '[Auth] Login Success',
  props<TokenResponse>()
);

export const logInFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: Error }>()
);

export const loadUser = createAction(
  '[Auth] Load User',
  props<{ token: string }>()
);

export const loadUserSuccess = createAction(
  '[Auth] Load User Success',
  props<{ payload: IAdminTokenPayload }>()
);

export const loadUserFailure = createAction(
  '[Auth] Loud User Failure',
  props<{ error: Error }>()
);

export const logOut = createAction('[Auth] LogOut');

export const logOutSuccess = createAction('[Auth] LogOut Success');

export const forgotPassword = createAction(
  '[Auth] Request Forgot Password',
  props<{ username: string }>()
);

export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot Password Success',
  props<ResetResponse>()
);

export const forgotPasswordFailure = createAction(
  '[Auth] Forgot Password Failure',
  props<{ error: Error }>()
);

export const validPasswordToken = createAction(
  '[Auth] Request Validate Password Token',
  props<{ token: string }>()
);

export const validPasswordTokenSuccess = createAction(
  '[Auth] Validate Password Token Success'
);

export const validPasswordTokenFailure = createAction(
  '[Auth] Validate Password Token Failure',
  props<{ error: Error }>()
);

export const resetPassword = createAction(
  '[Auth] Request Reset Password',
  props<{ password: string }>()
);
